var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mode-switcher btn-group mode-switcher__fixed"},_vm._l((_vm.options),function(ref){
var icon = ref.icon;
var label = ref.label;
var value = ref.value;
return _c('DsButton',{key:value,staticClass:"mode-switcher__button",attrs:{"theme":_vm.mode === value ? 'primary' : 'light',"variant":"alt","title":label},on:{"click":function () { _vm.mode = value }}},[_c('DsIcon',_vm._b({staticClass:"mode-switcher__button__icon"},'DsIcon',{ icon: icon },false)),_c('span',{staticClass:"mode-switcher__label"},[_vm._v(_vm._s(label))])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }